import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getTeam,
  inviteMember,
  setMemberRole,
  removeMember,
} from '../services/teamService';
import type { InviteRequest } from '../types/team';

export function useTeam() {
  return useQuery({
    queryKey: ['team'],
    queryFn: getTeam,
  });
}

export function useInviteMember() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: InviteRequest) => inviteMember(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['team'] }),
  });
}

export function useSetMemberRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ username, role }: { username: string; role: string }) =>
      setMemberRole(username, role),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['team'] }),
  });
}

export function useRemoveMember() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (username: string) => removeMember(username),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['team'] }),
  });
}
